export default {
  paymentMethods: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/paymentMethods/state.js